import appSettings from "../utils/AppSetting";
import useAxios from "../utils/UseAxios";

var authController = "/authentication";

const AuthenticationService = () => {
  const baseUrl = `${appSettings.services.Authentication.apiUrl}`
  const apiPermGroupCode = `${appSettings.services.Authentication.apiPermGroupCode}`;
  const { loading, error,  post,  } = useAxios(baseUrl, {"Content-Type": "application/json"}, apiPermGroupCode);
  
  const getMenuList = async (param) => {
    try {
      const response = await post(`${authController}/listMenu/list`, param);
      return response;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  return {
    loading,
    error,
    getMenuList,
  };
};

export default AuthenticationService;
